import React from 'react';
import MainHeader from '../main-header';
import {
  SelectAllDays,
  DayCheckBox,
} from '../parent/custom-checkbox';
import Image from '../../components/loggedout/common/Image';
import i18n from '../../../js/utils/i18n';
import WeeklyGoalSlider from '../weekly-goal-slider';

const OnboardingWeeklySchedule = ({
  selectAllCheck,
  handleSelectAllDays,
  weekDays,
  dayHandler,
  FormError,
  timeTile,
  selectedTimeTile,
  showError,
  showDropDown,
  selectAmPm,
  timeList,
  setActiveAmPm,
  setSelectedTimeTile,
  timeListHandler,
  submitHandler,
  dropDownHandler,
  dropdownRef,
  showReminderText,
  selectedGrade,
  weeklyGoalProgress,
  setWeeklyGoalProgress,
  isOneTapEnabled,
  behaviourQuestEnabled,
  getSelectedDays
}) => {
  return (
    <div className='parent-onboarding onboarding-weekly ela-signup-sections'>
      <MainHeader showLogoutLink={true} isOneTapEnabled={isOneTapEnabled}/>
      <div className="wrapper container" >
        <div className="weekly-schedule__header">
          <h2>Set Your Child's Weekly Learning Goal</h2>
          <p>Receive timely <strong>emails</strong> to help your child reach the goal. Modify anytime.</p>
        </div>
        <div className="weekly-schedule-wrapper">
          <h2 className="step-points">
            {
              behaviourQuestEnabled ?
              <>
                1. Set daily schedule - {weeklyGoalProgress} minutes a day
              </>
              :
              <>
                1. Set <i>weekly goal</i> - {weeklyGoalProgress} minutes a week
              </>
            }
          </h2>
          <WeeklyGoalSlider progress={weeklyGoalProgress} onChange={setWeeklyGoalProgress} behaviourQuestEnabled={behaviourQuestEnabled}/>
          <h2 className="step-points step-point2">
            {
              behaviourQuestEnabled ?
              <>
                2. Select weekly schedule - {getSelectedDays().length > 1 ? `${getSelectedDays().length} days`: `${getSelectedDays().length} day`} a week
              </>
              :
              <>
                2. Select {i18n.t('practice')} <i>days</i>
              </>
            }
          </h2>
          <div className="days-container">
            <SelectAllDays
              isChecked={selectAllCheck}
              onChange={handleSelectAllDays}
            />
            <DayCheckBox data={weekDays} checkBoxHandler={dayHandler} />
            {showError.weekDaysSelectError ? (
              <p className="error-state">
                <Image src={FormError} alt="error" />
                Please select atleast 1 practice day.
              </p>
            ) : null}
          </div>
          <h2 className="step-points step-point2">3. Select {i18n.t('practice')} <i>time</i></h2>
          <div className="time-container">
            <ul className="time-tile-section">
              {timeTile.map((val) => {
                let activeTimeTile =
                  val.time === selectedTimeTile.time &&
                  val.isAmPm === selectedTimeTile.isAmPm
                    ? 'active-time-tile'
                    : '';
                return (
                  <li
                    key={val.id}
                    className={activeTimeTile}
                    onClick={() => {
                      if(behaviourQuestEnabled) {
                        trackAnalyticsEvent('Interacted Weekly Goal Page', {'Clicked On': 'Reminder Time'});
                      }
                      setSelectedTimeTile(val);
                    }}
                  >{`${val.time} ${val.isAmPm}`}</li>
                );
              })}
            </ul>
            <h2 className="or-seperator">OR</h2>
            <div className="time-dropdown-section">
              <h2>Set your own time</h2>
              <div ref={dropdownRef} className="time-dropdown-container">
                <div
                  className="time-dropdown--loggedout"
                >
                  <div
                    className="selected-time"
                    onClick={(e) => dropDownHandler(e)}
                  >
                    {selectedTimeTile.time}
                  </div>
                  {showDropDown && (
                    <ul>
                      {timeList.map((val) => (
                        <li
                          onClick={() => timeListHandler(val)}
                        >{`${val.time} ${val.isAmPm}`}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              <div className="am-pm-wrapper">
                <span
                  className={
                    'am-pm-cta ' + (selectAmPm == 'AM' ? 'active-ampm' : '')
                  }
                  onClick={() => setActiveAmPm('AM')}
                >
                  AM
                </span>
                <span
                  className={
                    'am-pm-cta ' + (selectAmPm == 'PM' ? 'active-ampm' : '')
                  }
                  onClick={() => setActiveAmPm('PM')}
                >
                  PM
                </span>
              </div>
            </div>
          </div>
        </div>
      <div className="weekly-goal-fixed-cta">
        { showReminderText && <button onClick={()=>submitHandler(true)} className="skip-cta">Skip</button> }
        <div>
          <button onClick={()=>submitHandler(false)} className="schedule-submit-cta">Set Weekly Goal</button>
          <p>You'll get email reminders</p>
        </div>
      </div>
      </div>
    </div>
  );
}
export default  OnboardingWeeklySchedule;